module.exports = __webpack_public_path__ + "static/media/7_4.37d553d4.JPG";